module.exports = __webpack_public_path__ + "static/media/6S.dd29ca5a.svg";